import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { STATIC } from '../../lib/queryPresets';
import * as svc from '../../services/files/taskFilesService';

export function useTaskFiles(taskId: string | undefined) {
  return useQuery({
    ...STATIC,
    queryKey: ['task-files', taskId ?? ''],
    queryFn: () => svc.listTaskFiles(taskId!),
    enabled: !!taskId,
  });
}

export function useLinkFile(taskId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ fileId, linkedBy }: { fileId: string; linkedBy: string }) =>
      svc.linkFile(taskId, fileId, linkedBy),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['task-files', taskId] });
    },
  });
}

export function useUnlinkFile(taskId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (fileId: string) => svc.unlinkFile(taskId, fileId),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['task-files', taskId] });
    },
  });
}
